<script lang="ts">
	import { capitalize } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import { getOperationFinancialInstrumentString } from '@app/models/api/enums/OperationFinancialInstrumentEnum';
	import { getOperationCategoryString } from '@app/models/api/enums/OperationCategoryEnum';
	import { ButtonTextPrimary } from '@wiseed/wikit';
	import { urls } from '@app/urls';
	import { Box } from '@wiseed/wikit';
	import { OperationFinancialInstrumentEnum } from '@app/models/api/enums/OperationFinancialInstrumentEnum.js';

	export let operation;
</script>

<Box props={{ color: 'bg-dashboardBg' }}>
	<p class="font-semibold text-2xl">
		* <span class="inline-block first-letter:uppercase">{$t('operation.risk.title')}</span>
	</p>
	<p>
		{#if operation.financialInstrument !== OperationFinancialInstrumentEnum.STOCKS}
			{$t('operation.risk.text', {
				values: {
					operationName: operation.name,
					operationInstrument: capitalize(
						getOperationFinancialInstrumentString(operation.financialInstrument, $t)
					),
					operationSector: capitalize(getOperationCategoryString(operation.category))
				}
			})}
		{:else}
			{$t('operation.risk.textShares', {
				values: {
					operationName: operation.name,
					operationInstrument: capitalize(
						getOperationFinancialInstrumentString(operation.financialInstrument, $t)
					),
					operationSector: capitalize(getOperationCategoryString(operation.category))
				}
			})}
		{/if}
	</p>
	<ButtonTextPrimary
		props={{
			label: capitalize($t('learnMore')),
			href: urls.LEGAL.RISK_WARNING
		}}
	/>
</Box>
